<template>
  <article id="HOME">
    <VNavigationCardsFlat v-if="isNavigationFlatComputed" />
    <VNavigationCardsGrouped v-else />
  </article>
</template>

<script>
import TitleMixin from '@/mixins/title';

export default {
  name: 'Home',

  components: {
    VNavigationCardsFlat: () => import('@/components/UI/NavigationCards/Flat'),
    VNavigationCardsGrouped: () => import('@/components/UI/NavigationCards/Grouped'),
  },

  mixins: [TitleMixin],

  props: {
    isNavigationFlat: {
      type: Boolean,
      required: false,
    },
  },

  data() {
    return { windowWidth: window.innerWidth };
  },

  computed: {
    isNavigationFlatComputed() {
      return this.isNavigationFlat || this.windowWidth < 1500;
    },
  },

  created() {
    this.$webtrekk.viewPage('startseite', 'basket');
    window.addEventListener('resize', this.onResize);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },

  methods: {
    onResize() {
      this.windowWidth = window.innerWidth;
    },
  },
};
</script>
